import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {userAPI} from '../../../api'
import toastr from 'toastr';
import { useIntl } from 'react-intl'

const initialValues = {
  agreed: false,
}

const requestSchema = Yup.object().shape({
  agreed: Yup.boolean().required('Required').oneOf([true], 'You must agree to continue')
});

const AccountDelete = () => {
  const [handling, setHandling] = useState(false)

  const navigate = useNavigate()

  const intl = useIntl()
  
  const formik = useFormik({
    initialValues,
    validationSchema: requestSchema,
    onSubmit: async (values) => {
      setHandling(true)
      await userAPI.delete_()
      setHandling(false)
      toastr.success(intl.formatMessage({id: `user.delete_account.deleted`}))
      navigate('/a/sign-out')
    },
  })

  return (
    <>
    <form
      className='form w-100 fv-plugins-bootstrap5 mw-500px fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className='text-center mb-5'>
        <h2 className='text-dark pb-0'>{intl.formatMessage({id: `user.delete_account.title`})}</h2>
      </div>

      <p>
      {intl.formatMessage({id: `user.delete_account.description`})}
      </p>

      <div className='fv-row mb-5'>
        <div className="form-check form-check-custom form-check-solid flex-center">
          <input 
            className="form-check-input" 
            type="checkbox" 
            checked={formik.values.agreed}
            onChange={(e) =>
              formik.setFieldValue("agreed", e.target.checked)
            }
            onBlur={formik.handleBlur}
            id="agreed"
          />
          <label className="form-check-label text-white" htmlFor="agreed">
            {intl.formatMessage({id: `user.delete_account.agree`})}
          </label>
        </div>
      </div>
      
      <div className='d-flex flex-row justify-content-center'>
        <button
          type='button'
          className='btn btn-dark btn-sm me-4'
          onClick={() => navigate('/c')}
        >
          {intl.formatMessage({id: `user.delete_account.cancel`})}
        </button>
        <button
          type='submit'
          className='btn btn-sm btn-danger'
          disabled={handling || !formik.isValid}
        >
          {!handling && <span className='indicator-label'>{intl.formatMessage({id: `user.delete_account.submit`})}</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: `general.please_wait`})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
    </>
  )
}

export default AccountDelete